import core from './commuCore'
const output = {}

// 获取全部敏感词
function reqGetAllSensitiveWord (data) {
  return core.ajax({}, '/sensitive/all')
}
output.reqGetAllSensitiveWord = reqGetAllSensitiveWord

// 新增敏感词
function reqAddSensitiveWord (data) {
  return core.ajax(data, '/sensitive/add', 'POST')
}
output.reqAddSensitiveWord = reqAddSensitiveWord

// 删除敏感词
function reqDelSensitiveWord (data) {
  return core.ajax(data, '/sensitive/del', 'DELETE')
}
output.reqDelSensitiveWord = reqDelSensitiveWord

export default output
